import { EuiSuperSelect } from '@elastic/eui';

export const SelectorSimple = (props) =>{
  
  let propiedades = {
    options:props.options ? props.options : [],
    valueOfSelected: props.valueOfSelected || undefined,
    onChange: props.onChange,
    isInvalid: props.isInvalid ? props.isInvalid : false,
    disabled: props.disabled,
    isLoading: props.disabled || props.options  ? false : true,
    compressed: false
  }

  return (
    <EuiSuperSelect {...{...props,...propiedades}}/>
  )
}
export default SelectorSimple